import { getFeathersClient } from "@/pages/chat/feathers-client"

export interface AttachmentCreateRequest {
	filename: string
	contentType: string
	size: number
}

export interface AttachmentCreateResponse {
	uploadUrl: string
	uploadFields: Record<string, string>
	attachmentId: string
}

export class ImageUploader {
	private feathersClient = getFeathersClient()

	async uploadImage(file: File): Promise<string> {
		const createRequest: AttachmentCreateRequest = {
			filename: file.name,
			contentType: file.type,
			size: file.size
		}

		const createResponse: AttachmentCreateResponse = await this.feathersClient
			.service('attachments')
			.create(createRequest)

		const formData = new FormData()

		Object.entries(createResponse.uploadFields).forEach(([key, value]) => {
			formData.append(key, value)
		})
		
		formData.append('file', file)

		const uploadResponse = await fetch(createResponse.uploadUrl, {
			method: 'POST',
			body: formData
		})

		if (!uploadResponse.ok) {
			throw new Error(`Upload failed: ${uploadResponse.statusText}`)
		}

		return createResponse.attachmentId
	}
}
